<form class="w-100 h-100 form" [formGroup]="commentForm" (ngSubmit)="sendData()">
  <h4 class="text-center">Nuevo Comentario</h4>
  <div class="row mx-0 my-3 p-0 w-100">
    <div class="col-12 pl-xl-0 mt-2 mb-4">
      <div class="vs-outline-editCard btn-custom-banner">
        <img class="given-img mb-4" [src]="fileImg64 | safeDom" alt="img-banner" *ngIf="fileImg64">
        <div class="btn-custom-file w-100">
          <label for="file-upload-logo" class="custom-file-upload h-fit-content p-3">
            <mat-icon>{{!fileImg64 ? 'image': '' }} </mat-icon>
            <span class="my-2" *ngIf="!wrongSize">
              Elegir imagen de 50px x 50px
            </span>
            <span class="my-2 text-danger" *ngIf="wrongSize">{{wrongSize}}</span>
          </label>
          <input id="file-upload-logo" type="file" accept="image/*" (change)="getBase64($event)" />
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="title" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="col-6">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido</mat-label>
          <input matInput placeholder="Apellido" formControlName="subTitle" required>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
    <!--    <div class="col-6">-->
    <!--      <div class="mb-3">-->
    <!--        <h5 class="m-0 fw-bold">Tamano de imagen</h5>-->
    <!--        <mat-form-field appearance="outline" class="w-100">-->
    <!--          <input matInput placeholder="1, 2, 3" formControlName="codeImg">-->
    <!--        </mat-form-field>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="col-12">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Comentario</mat-label>
          <textarea matInput #content [maxlength]="maxLength" placeholder="Comentario" formControlName="comment" required rows="4"> </textarea>
          <mat-hint align="end">{{content.value?.length || 0}}/{{maxLength}}</mat-hint>
          <mat-error>Este campo es <b>Requerido</b></mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" type="submit" [disabled]="commentForm.invalid">
      Guardar
    </button>
  </div>
</form>
